import {makeProductDetailBreadCrumbItems} from "./productDetail";
import makeBreadCrumbList from "../objects/breadcrumbList";

function makeBreadcrumbsProductDetailSchema(product, ctx) {
  const items = makeProductDetailBreadCrumbItems(product, ctx);
  return makeBreadCrumbList(items, ctx);
}

export default makeBreadcrumbsProductDetailSchema;
